import type { LocationQueryRaw, RouteLocationNormalized } from "#vue-router";
import { AuthPages } from "~/auth/types/auth";
import { isFeatureEnabled } from "~/common/composables/is-feature-enabled";

const YOU_ONBOARDING_PATH = "/onboarding/you";

export default defineNuxtPlugin(() => {
  const user = useUser();
  const userProfile = useUserProfile();

  function navigateToAuthPage(authPath: AuthPages, route: RouteLocationNormalized, queryParams?: LocationQueryRaw) {
    if (route.path === authPath) {
      return Promise.resolve();
    }
    return navigateTo({ path: authPath, query: { ...queryParams, redirectUrl: route.fullPath } });
  }

  addRouteMiddleware(
    "auth",
    (to) => {
      const isLoggedIn = Boolean(user.value);
      const isGuest = !isLoggedIn;
      const isGuestAllowed = to.meta.layout === "auth" || to.meta.allow_guest;
      const isB2CAdmin = !!userProfile.value;

      // Allow access for guests with accessToken and playlistId (shared content)
      if (isGuest && to.query.playlistId && to.query.accessToken) {
        return navigateToAuthPage(AuthPages.SIGN_UP, to, to.query);
      }

      if (isGuest && !isGuestAllowed && to.query.playlistId) {
        return navigateToAuthPage(AuthPages.LOGIN, to, { playlistPermissionError: "true" });
      }

      if (isGuest && !isGuestAllowed) {
        return navigateToAuthPage(AuthPages.LOGIN, to);
      }

      if (
        isFeatureEnabled("enable_you_onboarding_redirect") &&
        isLoggedIn &&
        isB2CAdmin &&
        !user.value?.tenantId &&
        to.path !== YOU_ONBOARDING_PATH &&
        user.value?.canMigrateB2CToAdvantage
      ) {
        return navigateTo({ path: YOU_ONBOARDING_PATH, query: { ...to.query, redirectUrl: to.fullPath } });
      }
    },
    { global: true }
  );
});
